/**
 * Regole di impaginazione del drawer "Messaggi" (logica pura, testata).
 *
 * - Modalita' estesa: sotto i 1024px una colonna sola (lista OPPURE chat).
 * - Modalita' compatta: il drawer occupa il 60% della finestra (tutta sotto i
 *   768px); se resta meno di 900px per lista + chat si passa a una colonna,
 *   cosi' nessun elemento della chat viene tagliato.
 */

export type DrawerMode = 'full' | 'compact';
export type DrawerColumns = 'both' | 'list' | 'chat';

export const FULL_SINGLE_COLUMN_BELOW = 1024;
export const COMPACT_MIN_TWO_COLUMNS = 900;
export const COMPACT_FULL_WIDTH_BELOW = 768;
export const COMPACT_MIN_WIDTH = 420;

/** Larghezza in px del drawer compatto per una data finestra. */
export function compactDrawerWidth(viewportWidth: number): number {
  if (viewportWidth < COMPACT_FULL_WIDTH_BELOW) return viewportWidth;
  return Math.min(viewportWidth, Math.max(Math.round(viewportWidth * 0.6), COMPACT_MIN_WIDTH));
}

export function isSingleColumnLayout(mode: DrawerMode, viewportWidth: number): boolean {
  if (mode === 'full') return viewportWidth < FULL_SINGLE_COLUMN_BELOW;
  return compactDrawerWidth(viewportWidth) < COMPACT_MIN_TWO_COLUMNS;
}

/** Cosa mostrare: entrambe le colonne, solo la lista o solo la chat aperta. */
export function visibleColumns(singleColumn: boolean, hasSelectedChat: boolean): DrawerColumns {
  if (!singleColumn) return 'both';
  return hasSelectedChat ? 'chat' : 'list';
}

/**
 * Il drawer si chiude quando l'utente cambia pagina (es. "Apri scheda" del
 * Lead/Cliente), altrimenti la pagina nuova resta coperta. Si ignora il cambio
 * pagina nei primi istanti dopo l'apertura: il vecchio link /whatsapp apre il
 * drawer e contemporaneamente reindirizza alla dashboard.
 */
export const ROUTE_CHANGE_GRACE_MS = 1500;

export function shouldCloseOnRouteChange(args: {
  prevPath: string | null;
  nextPath: string;
  isOpen: boolean;
  msSinceOpen: number;
}): boolean {
  if (!args.isOpen || args.prevPath === null) return false;
  if (args.prevPath === args.nextPath) return false;
  return args.msSinceOpen >= ROUTE_CHANGE_GRACE_MS;
}
